// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewGateTicketModal {
  display: flex;
  flex-direction: column;
  width: 1014px;
  height: 700px;
  align-self: center;
  padding: 0;
  border-width: 0;
}

  .ViewGateTicketModal-image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 575px;
    width: 1014px;
    background-color: var(--color-grayscale-3);
  }

  .ViewGateTicketModal-image-rotation0 {
      height: 575px;
      width: auto;
      max-width: 1014px;
      transform: rotate(0deg);
      margin: 0 auto;
    }

  .ViewGateTicketModal-image-rotation1 {
      width: 575px;
      height: auto;
      max-height: 1014px;
      transform: rotate(90deg);
      margin: 0 auto;
    }

  .ViewGateTicketModal-image-rotation2 {
      height: 575px;
      width: auto;
      max-width: 1014px;
      transform: rotate(180deg);
      margin: 0 auto;
    }

  .ViewGateTicketModal-image-rotation3 {
      width: 575px;
      height: auto;
      max-height: 1014px;
      transform: rotate(270deg);
      margin: 0 auto;
    }

  .ViewGateTicketModal-bold-text {
    font-weight: 600;
  }

  .ViewGateTicketModal-rotate-icon {
    width: 30px;
    height: 30px;
    color: red;
    position: absolute;
    bottom: 155px;
    right: 120px;
    z-index: 1;
    cursor: pointer;
  }

  .ViewGateTicketModal-rotate-icon__right {
      right: 60px;
      transform: scaleX(-1);
      transform: scaleX(-1);
      transform: scaleX(-1);
      transform: scaleX(-1);
      filter: fliph;
      filter: "FlipH";
    }

  .ViewGateTicketModal-editable-field {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 40px;
    border: 1px var(--theme-1-color-0) solid;
    border-radius: 2px;
    margin-top: 4px;
  }

  .ViewGateTicketModal-editable-field-label {
      text-transform: capitalize;
    }

  .ViewGateTicketModal-editable-field .r-editable-field__text {
      text-align: center;
    }

  .ViewGateTicketModal-editable-field .r-editable-field__date-time-picker {
      position: absolute;
      top: 20px;
    }

  .ViewGateTicketModal-detail-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px 30px;
  }

  .ViewGateTicketModal-detail-bar-attachment-info {
      display: flex;
      flex-direction: column;
      width: 240px;
    }

  .ViewGateTicketModal-detail-bar-date-fields {
      display: flex;
      flex-grow: 0;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-right: 60px;
      width: 371px;
    }

  .ViewGateTicketModal-detail-bar-column {
      display: flex;
      flex-direction: column;
    }

  .ViewGateTicketModal-action-items {
    display: flex;
    align-self: flex-end;
    flex-direction: row;
    align-items: flex-end;
  }

  .ViewGateTicketModal-action-items > * {
      margin-left: 12px;
      width: 120px;
      height: 40px;
    }

  .ViewGateTicketModal-transfer-icon {
    width: 27px;
    height: 24px;
    color: var(--theme-1-color-0);
    margin: 10px 12px 0;
    cursor: pointer;
  }
`, "",{"version":3,"sources":["webpack://./app/pages/DispatchPage/components/DispatchPageOrderLegStopInfo/components/ViewGateTicketModal/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,eAAe;AA8IjB;;EA5IE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,0CAA0C;EAC5C;;EAGE;MACE,aAAa;MACb,WAAW;MACX,iBAAiB;MACjB,uBAAuB;MACvB,cAAc;IAChB;;EAEA;MACE,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,wBAAwB;MACxB,cAAc;IAChB;;EAEA;MACE,aAAa;MACb,WAAW;MACX,iBAAiB;MACjB,yBAAyB;MACzB,cAAc;IAChB;;EAEA;MACE,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,yBAAyB;MACzB,cAAc;IAChB;;EAGF;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,eAAe;EAWjB;;EATE;MACE,WAAW;MACX,qBAAqB;MACrB,qBAAqB;MACrB,qBAAqB;MACrB,qBAAqB;MACrB,aAAa;MACb,eAAe;IACjB;;EAGF;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;EAcjB;;EAZE;MACE,0BAA0B;IAC5B;;EAEA;MACE,kBAAkB;IACpB;;EAEA;MACE,kBAAkB;MAClB,SAAS;IACX;;EAGF;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EAsBpB;;EApBE;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;IACd;;EAEA;MACE,aAAa;MACb,YAAY;MACZ,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;IACd;;EAEA;MACE,aAAa;MACb,sBAAsB;IACxB;;EAGF;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;EAOvB;;EALE;MACE,iBAAiB;MACjB,YAAY;MACZ,YAAY;IACd;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;EACjB","sourcesContent":[".ViewGateTicketModal {\n  display: flex;\n  flex-direction: column;\n  width: 1014px;\n  height: 700px;\n  align-self: center;\n  padding: 0;\n  border-width: 0;\n\n  &-image-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 575px;\n    width: 1014px;\n    background-color: var(--color-grayscale-3);\n  }\n\n  &-image {\n    &-rotation0 {\n      height: 575px;\n      width: auto;\n      max-width: 1014px;\n      transform: rotate(0deg);\n      margin: 0 auto;\n    }\n\n    &-rotation1 {\n      width: 575px;\n      height: auto;\n      max-height: 1014px;\n      transform: rotate(90deg);\n      margin: 0 auto;\n    }\n\n    &-rotation2 {\n      height: 575px;\n      width: auto;\n      max-width: 1014px;\n      transform: rotate(180deg);\n      margin: 0 auto;\n    }\n\n    &-rotation3 {\n      width: 575px;\n      height: auto;\n      max-height: 1014px;\n      transform: rotate(270deg);\n      margin: 0 auto;\n    }\n  }\n\n  &-bold-text {\n    font-weight: 600;\n  }\n\n  &-rotate-icon {\n    width: 30px;\n    height: 30px;\n    color: red;\n    position: absolute;\n    bottom: 155px;\n    right: 120px;\n    z-index: 1;\n    cursor: pointer;\n\n    &__right {\n      right: 60px;\n      transform: scaleX(-1);\n      transform: scaleX(-1);\n      transform: scaleX(-1);\n      transform: scaleX(-1);\n      filter: fliph;\n      filter: \"FlipH\";\n    }\n  }\n\n  &-editable-field {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 160px;\n    height: 40px;\n    border: 1px var(--theme-1-color-0) solid;\n    border-radius: 2px;\n    margin-top: 4px;\n\n    &-label {\n      text-transform: capitalize;\n    }\n\n    .r-editable-field__text {\n      text-align: center;\n    }\n\n    .r-editable-field__date-time-picker {\n      position: absolute;\n      top: 20px;\n    }\n  }\n\n  &-detail-bar {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 20px 30px;\n\n    &-attachment-info {\n      display: flex;\n      flex-direction: column;\n      width: 240px;\n    }\n\n    &-date-fields {\n      display: flex;\n      flex-grow: 0;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      margin-right: 60px;\n      width: 371px;\n    }\n\n    &-column {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  &-action-items {\n    display: flex;\n    align-self: flex-end;\n    flex-direction: row;\n    align-items: flex-end;\n\n    > * {\n      margin-left: 12px;\n      width: 120px;\n      height: 40px;\n    }\n  }\n\n  &-transfer-icon {\n    width: 27px;\n    height: 24px;\n    color: var(--theme-1-color-0);\n    margin: 10px 12px 0;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
